
import React from 'react';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { Focus, Check, AlertCircle } from 'lucide-react';

type MessageFieldProps = {
  control: any;
  maxChars: number;
  messageRef?: React.RefObject<HTMLTextAreaElement>;
};

const MessageField = ({ control, maxChars, messageRef }: MessageFieldProps) => {
  // Watch the message value to update character count
  const messageValue = control._formValues.message || '';
  const characterCount = messageValue.length;

  return (
    <FormField
      control={control}
      name="message"
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel className="text-gray-100">Message</FormLabel>
          <FormControl>
            <div className="relative">
              <Textarea 
                ref={messageRef}
                placeholder="How can we help you?" 
                rows={4} 
                {...field} 
                className="bg-white/5 border-white/20 focus:border-[#33C3F0]/50 text-white placeholder:text-gray-400 transition-all duration-200 focus:ring-1 focus:ring-[#33C3F0]/30 hover:border-white/30 resize-none pr-10"
                aria-required="true"
              />
              
              {/* Validation icon */}
              {field.value && (
                <div className="absolute right-3 top-4">
                  {fieldState.invalid ? (
                    <AlertCircle className="h-4 w-4 text-red-400" />
                  ) : (
                    <Check className="h-4 w-4 text-green-400" />
                  )}
                </div>
              )}
              
              <div className="absolute bottom-2 right-3 flex items-center text-xs text-gray-400">
                <Focus className="h-3 w-3 mr-1 opacity-70" />
                <span className={`${characterCount > maxChars - 50 ? (characterCount > maxChars ? 'text-red-400' : 'text-amber-300') : ''}`}>
                  {characterCount}/{maxChars}
                </span>
              </div>
            </div>
          </FormControl>
          <FormMessage className="text-[#FF6B6B] text-xs mt-1" />
        </FormItem>
      )}
    />
  );
};

export default MessageField;
